import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { InventoryItem, RoomInventory } from '../../../shared/types/Inventory';
import { ChevronLeftIcon, ChevronRightIcon, PlusIcon, MoreHorizontalIcon } from 'lucide-react';
import { AddInventoryModal } from '../components/AddInventoryModal';
export function Inventory() {
  const {
    t
  } = useTranslation('shops');
  // Date range state
  const [dateRange, setDateRange] = useState('05/06/2026 - 06/06/2026');
  // Modal state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  // Mock inventory data based on the screenshot
  const [inventoryData, setInventoryData] = useState<InventoryItem[]>([{
    date: '2026-05-06',
    dayOfWeek: 'Wednesday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-07',
    dayOfWeek: 'Thursday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-08',
    dayOfWeek: 'Friday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-09',
    dayOfWeek: 'Saturday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }, {
    date: '2026-05-10',
    dayOfWeek: 'Sunday',
    roomTypes: [{
      roomType: 'Premium Overwater Villa',
      roomCode: 'POWVDTAC',
      availableRooms: 50,
      cta: false,
      ctd: false,
      blo: false
    }, {
      roomType: 'Water Villa',
      roomCode: 'SUNSIYAMEX',
      availableRooms: 3,
      cta: false,
      ctd: false,
      blo: false
    }]
  }]);
  // Room type filter
  const [roomTypeFilter, setRoomTypeFilter] = useState('all');
  // Format date for display
  function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')} Oct ${date.getFullYear()}`;
  }
  // Handle adding new inventory
  const handleSaveInventory = (inventoryData: any) => {
    console.log('New inventory data:', inventoryData);
    // Here you would process the new inventory data and update the state
    // This is just a placeholder for the actual implementation
    // For demonstration, let's add a simple log message
    alert('Inventory added successfully!');
  };
  return <div className="space-y-6" data-id="element-12098" data-mp="3plu6kz4ksm29">
      <div className="flex justify-between items-center" data-id="element-12099" data-mp="2959exrz5bwuz">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-12100" data-mp="297voty9ieogd">
          {t('pages.Inventory.inventory')}
        </h1>
        <button onClick={() => setIsAddModalOpen(true)} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center" data-id="element-12101" data-mp="2uc0d3d98p5it">
          <PlusIcon size={18} className="mr-1" data-id="element-12102" data-mp="2pj760iqatl3k" />
          {t('components.AddInventoryModal.add_inventory')}
        </button>
      </div>
      {/* Date range and filters */}
      <div className="flex flex-wrap gap-3" data-id="element-12103" data-mp="2fof79bkzcs77">
        <div className="relative" data-id="element-12104" data-mp="3daupwgp57vwc">
          <input type="text" className="border border-gray-300 rounded-md px-3 py-2 w-48" value={dateRange} readOnly data-id="element-12105" data-mp="3d9tf8dc1hbf5" />

          <div className="absolute inset-y-0 right-0 flex items-center pr-2" data-id="element-12106" data-mp="33cf2anpbr4rl">
            <ChevronLeftIcon size={16} className="text-gray-400 cursor-pointer mr-1" data-id="element-12107" data-mp="33ehw7itlli1l" />

            <ChevronRightIcon size={16} className="text-gray-400 cursor-pointer" data-id="element-12108" data-mp="1ry1hxsts57gb" />
          </div>
        </div>
        <select className="border border-gray-300 rounded-md px-3 py-2" value={roomTypeFilter} onChange={e => setRoomTypeFilter(e.target.value)} data-id="element-12109" data-mp="1n0jfmla9pqha">
          <option value="all" data-id="element-12110" data-mp="7g0qptcw3ymy">
            {t('components.AddInventoryModal.select_room_type')}
          </option>
          <option value="premium-overwater" data-id="element-12111" data-mp="cchdaj4fy4xx">
            {t('components.AddInventoryModal.premium_overwater_villa')}
          </option>
          <option value="water-villa" data-id="element-12112" data-mp="m4wsj8ocsff4">
            {t('components.AddInventoryModal.water_villa')}
          </option>
        </select>
      </div>
      {/* Inventory Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto" data-id="element-12113" data-mp="q7te9896wrna">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-12114" data-mp="v2z0y9af2acf">
          <thead className="bg-gray-50" data-id="element-12115" data-mp="1033g9vzl8z12">
            <tr data-id="element-12116" data-mp="101sh69h38fga">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12117" data-mp="2wwojizb406fq">
                {t('pages.Inventory.room_type')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12118" data-mp="2tvv8t4i9by6s">
                {t('pages.Inventory.available_rooms')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12119" data-mp="33qn4g2sa4ayx">
                {t('pages.Inventory.cta')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12120" data-mp="38sm9dh3o3fxz">
                {t('pages.Inventory.ctd')}
              </th>
              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12121" data-mp="3hkxxuxf80tbb">
                {t('pages.Inventory.blo')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12122" data-mp="3rgr7o91k28pe">
                {t('pages.CampaignDetails.actions')}
              </th>
            </tr>
          </thead>
          <tbody data-id="element-12123" data-mp="50k3u165wo4b">
            {inventoryData.map((day, dayIndex) => <Fragment key={day.date} data-id="element-12124" data-mp="9yu1cifd00t3" data-mpi={dayIndex}>
                {/* Date header */}
                <tr className="bg-gray-50" data-id="element-12125" data-mp="3rfv2wdn74gma">
                  <td colSpan={6} className="px-6 py-3" data-id="element-12126" data-mp="3retn5vv8j5y8">
                    <div className="font-medium text-gray-900" data-id="element-12127" data-mp="28vxvzfgnoq">
                      {formatDate(day.date)}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-12128" data-mp="3ih9n2q93zfp7">{day.dayOfWeek}</div>
                  </td>
                </tr>
                {/* Room inventory rows */}
                {day.roomTypes.map((room, roomIndex) => <tr key={`${day.date}-${room.roomCode}`} className="bg-white" data-id="element-12129" data-mp="38jv70rr3ksxf" data-mpi={roomIndex}>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-12130" data-mp="3dfu18vz3x55r">
                      <div className="text-sm font-medium text-gray-900" data-id="element-12131" data-mp="3sxlm93k4mvwh">
                        {room.roomType}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-12132" data-mp="3ouxbgqburewv">
                        {room.roomCode}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-12133" data-mp="3eznckbgr3nnb">
                      {room.availableRooms}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-12134" data-mp="3a1lt3pfexmbb">
                      <input type="checkbox" checked={room.cta} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].cta = !room.cta;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-12135" data-mp="357rc4tr6zlfx" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-12136" data-mp="2h5cj2yb4ody7">
                      <input type="checkbox" checked={room.ctd} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].ctd = !room.ctd;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-12137" data-mp="2h3i03pjf2vwr" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-12138" data-mp="284o5g4pncflu">
                      <input type="checkbox" checked={room.blo} onChange={() => {
                  const newData = [...inventoryData];
                  newData[dayIndex].roomTypes[roomIndex].blo = !room.blo;
                  setInventoryData(newData);
                }} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-12139" data-mp="286r5ziofdr4t" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right" data-id="element-12140" data-mp="3325y158wi6po">
                      <button aria-label="Inventory actions" className="text-gray-400 hover:text-gray-500" data-id="element-12141" data-mp="330bkwd3vfiw5">
                        <MoreHorizontalIcon size={18} aria-hidden="true" data-id="element-12142" data-mp="2bbrspxeye2pm" />
                      </button>
                    </td>
                  </tr>)}
              </Fragment>)}
          </tbody>
        </table>
      </div>
      {/* Add Inventory Modal */}
      <AddInventoryModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onSave={handleSaveInventory} data-id="element-12143" data-mp="1nkw4195snnml" />
    </div>;
}